export default __webpack_public_path__ + "static/media/add-device.1423826c.svg";